import { render } from "./kalio-toasts-container.vue?vue&type=template&id=4d9b9395"
import script from "./kalio-toasts-container.vue?vue&type=script&lang=js"
export * from "./kalio-toasts-container.vue?vue&type=script&lang=js"

import "./kalio-toasts-container.vue?vue&type=style&index=0&id=4d9b9395&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__